export function getStoredTranslations(localeId: string): Record<string, string> | undefined {
  const raw = localStorage.getItem(`${localeId}_translations`);
  if (!raw) {
    return undefined;
  }

  try {
    return JSON.parse(raw) as Record<string, string>;
  } catch {
    return undefined;
  }
}

export function getStoredTranslationsOrEmpty(localeId: string): Record<string, string> {
  return getStoredTranslations(localeId) ?? {};
}
